import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import ThemePackageListRow from './ThemePackageListRow';

export default class ThemePackageList extends Component {

    handleEditName = (id, name, oldName) => {

        let themePackage = this.getThemePackage(id);
        if (themePackage.name === name) return;

        themePackage.name = name;
        this.props.onEditPackage(themePackage);
    }

    handleEditType = (id, type, oldType) => {

        let themePackage = this.getThemePackage(id);
        if (themePackage.contractType === type) return;

        themePackage.contractType = type;
        this.props.onEditPackage(themePackage);
    }

    handleDuplicate = (id) => {
        this.props.onDuplicatePackage(id);
    }

    handleDelete = (id) => {
        this.props.onDeletePackage(id);
    }

    handleDefaultUserToggle = (id, value) => {
        let themePackage = this.getThemePackage(id);
        const ENUM = "Default";
        let hasAlreadyToggled = themePackage.organizationIds.includes(ENUM);
        let shouldUpdate = (value && !hasAlreadyToggled) || (!value && hasAlreadyToggled);

        if (!shouldUpdate)
            return;

        themePackage.organizationIds.push(ENUM);
        this.props.onEditPackage(themePackage);
    }

    handleDefaultGuestToggle = (id, value) => {
        let themePackage = this.getThemePackage(id);
        const ENUM = "DefaultForGuest";
        let hasAlreadyToggled = themePackage.organizationIds.includes(ENUM);
        let shouldUpdate = (value && !hasAlreadyToggled) || (!value && hasAlreadyToggled);

        if (!shouldUpdate)
            return;

        themePackage.organizationIds.push(ENUM);
        this.props.onEditPackage(themePackage);
    }

    handleDefaultPortfolioToggle = (id, value) => {
        let themePackage = this.getThemePackage(id);
        const ENUM = "DefaultForPortfolio";
        let hasAlreadyToggled = themePackage.organizationIds.includes(ENUM);
        let shouldUpdate = (value && !hasAlreadyToggled) || (!value && hasAlreadyToggled);

        if (!shouldUpdate)
            return;

        themePackage.organizationIds.push(ENUM);
        this.props.onEditPackage(themePackage);
    }

    getThemePackage = (id) => {
        let themePackage = this.props.themePackages.find(x => x.id === id);
        if (!themePackage) return null;

        return Object.assign({}, themePackage);
    }

    getRows = () => {
        if (this.props.themePackages.length === 0) return [];

        return this.props.themePackages.map((p, i) => (
            <ThemePackageListRow
                key={p.id}
                index={i}
                id={p.id}
                name={p.name}
                contractType={p.contractType}
                organizations={p.organizationIds}
                isLoading={this.props.isLoading}
                onEditName={this.handleEditName}
                onEditType={this.handleEditType}
                onDuplicate={this.handleDuplicate}
                onToggleDefaultUser={this.handleDefaultUserToggle}
                onToggleDefaultGuest={this.handleDefaultGuestToggle}
                onToggleDefaultPortfolio={this.handleDefaultPortfolioToggle}
                onDelete={this.handleDelete}
            />
        ));
    }

    render() {
        return (
            <Table className="category-list" striped bordered hover size="sm">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Contract Type</th>
                        <th>Organizations</th>
                        <th>Defaults (F/C/P)</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {this.getRows()}
                </tbody>
            </Table>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CategoryView/ThemePackageList.js